// export const PUBLIC_SERVER_URL="http://localhost:5001"
export const PUBLIC_SERVER_URL="https://fitwell-reactjs.onrender.com"
